import styled from 'styled-components'
import { prop, ifProp } from 'styled-tools'

const Preamble = styled.p`
  font-family: ${prop(`theme.typography.preamble.fontFamily`)};
  font-weight: ${prop(`theme.typography.preamble.fontWeight`)};
  font-size: ${prop(`theme.typography.preamble.fontSize`)};
  font-style: ${prop(`theme.typography.preamble.fontStyle`)};
  line-height: ${prop(`theme.typography.preamble.lineHeight`)};
  margin-top: ${prop(`theme.typography.preamble.marginTop`)};
  margin-bottom: ${prop(`theme.typography.preamble.marginBottom`)};
  text-transform: ${prop(`theme.typography.preamble.textTransform`)};
  letter-spacing: ${prop(`theme.typography.preamble.letterSpacing`)};

  color: ${prop(`theme.typography.preamble.color`, 'inherit')};
  text-align: ${prop('align', 'inherit')};

  ${ifProp('noMargins', `margin: 0;`)};

  ${(props) => props.theme.media.min.sm`
    font-size: ${prop(`theme.typography.preamble.fontSizeDesktop`)};
    line-height: ${prop(`theme.typography.preamble.lineHeightDesktop`)};
    text-shadow: none;
  `};
`

export default Preamble
